import {PersonBean} from '@/service/model/PersonBean'

export function formatPersonName(person?: PersonBean | null): string | undefined {
  const name = `${person?.firstname || ''} ${person?.lastname || ''}`.trim()
  if (name.length == 0) {
    return undefined
  }
  return name
}
